/**
 * Norwegian krone.
 */
export var NOK = {
  code: 'NOK',
  base: 10,
  exponent: 2
};